import React, { useState, useEffect,  } from 'react';
import AnimateOnScroll from './../../components/common/animate';
import { Link, useNavigate} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { X } from 'lucide-react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { toast } from 'react-toastify';
import Payment from './payment-modal.component';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';

export default function Appointment() {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedServices, setSelectedServices] = useState([]);
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
  const [blockedList, setBlockedList] = useState([]);
 const [page,setPages] = useState([]);
  const [paymentButton,setPaymentButton] = useState([]);
   const [payLaterButton,setPayLaterButton] = useState([]);
   const [refreshSlotsKey, setRefreshSlotsKey] = useState(0);
   const [salonHours, setSalonHours] = useState({ startTime: '10:00', endTime: '19:00' });

const forceRefetchSlots = () => {
  setRefreshSlotsKey(prev => prev + 1);
};
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    physicianCondition: '',
    physicianDetails: '',
    allergies: '',
    allergyDetails: '',
    pregnancy: '',
    pregnancyDetails: '',
    retinolUse: '',
    consent: false,
    acknowledgement: false,
  });
  const navigate = useNavigate();
  const [bookedSlots, setBookedSlots] = useState([]);

  const [errors, setErrors] = useState({});

   const getBookingSlots = (date) => {
    setLoading(true);
    DataService.bookingSlots(date,selectedServices)
      .then((response) => {
       setBookedSlots(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch services:', error);
      })
      .finally(() => setLoading(false));
  };
     const getPages = (date) => {
    setLoading(true);
    DataService.getPages(date)
      .then((response) => {

        let pages = response.data
        const appointmentBookingPage = pages.find(
          (page) => page.page_name === "Appointment Booking"
        );
         const paymentButton = pages.find(
          (page) => page.page_name === "Payment Button"
        );
         const payLaterButton = pages.find(
          (page) => page.page_name === "Pay Later Button"
        );
       setPages(appointmentBookingPage);
        setPaymentButton(paymentButton);
        setPayLaterButton(payLaterButton);


      })
      .catch((error) => {
        console.error('Failed to fetch services:', error);
      })
      .finally(() => setLoading(false));
  };

  const getServices = () => {
    setLoading(true);
    DataService.getServicesData()
      .then((response) => {
        setCategories(response.data); // expects object: { Facial: [{id, name, price}, ...], Waxing: [...] }
      })
      .catch((error) => {
        console.error('Failed to fetch services:', error);
      })
      .finally(() => setLoading(false));
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleSubCategoryToggle = (service,category) => {
  const exists = selectedServices.find((s) => s.id === service.id);
  let updatedServices;
  if (exists) {
    updatedServices = selectedServices.filter((s) => s.id !== service.id);
  } else {
    updatedServices = [
      ...selectedServices,
      {
        ...service,
        category: category, // ✅ attach category
      },
    ];
    console.log(updatedServices)
  }
  setSelectedServices(updatedServices);

  // Clear service error if a service is selected
  if (updatedServices.length > 0 && errors.services) {
    setErrors((prev) => ({ ...prev, services: '' }));
  }
  setFormData(prev => ({              // clear date/time but preserve other form fields
    ...prev,
    date: '',
    time: ''
  }));
  setBookedSlots([]);      

};

  const handleRemoveService = (id) => {
    setSelectedServices((prev) => prev.filter((s) => s.id !== id));
     setFormData(prev => ({              // clear date/time but preserve other form fields
    ...prev,
    date: '',
    time: ''
  }));
  setBookedSlots([]);     
  };

  const totalPrice = selectedServices.reduce((acc, s) => acc + s.price, 0);

  function generateTimeSlots(start, end, stepMinutes) {
    const slots = [];
    const [startH, startM] = start.split(":").map(Number);
    const [endH, endM] = end.split(":").map(Number);

    let current = new Date();
    current.setHours(startH, startM, 0, 0);

    const endTime = new Date();
    endTime.setHours(endH, endM, 0, 0);

    while (current <= endTime) {
      const hours = current.getHours().toString().padStart(2, "0");
      const minutes = current.getMinutes().toString().padStart(2, "0");
      slots.push(`${hours}:${minutes}`);
      current.setMinutes(current.getMinutes() + stepMinutes);
    }

    return slots;
  }

  function getToday() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  function getTodayString() {
    return new Date().toISOString().split("T")[0];
  }

  function getOneMonthFromToday() {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    date.setHours(23, 59, 59, 999);
    return date;
  }

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required.';
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Valid email is required.';
    if (!formData.phone.trim() || !/^[\d\s+()-]{6,}$/.test(formData.phone)) newErrors.phone = 'Valid phone number is required.';
    if (!formData.date) newErrors.date = 'Date is required.';
    if (!formData.time) newErrors.time = 'Time is required.';
    if (selectedServices.length === 0) newErrors.services = 'At least one service must be selected.';
     // Health & Safety questions
  if (!formData.physicianCondition) newErrors.physicianCondition = 'Please answer the physician care question.';
  if (formData.physicianCondition === 'yes' && !formData.physicianDetails.trim()) {
    newErrors.physicianDetails = 'Please provide physician condition details.';
  }

  if (!formData.allergies) newErrors.allergies = 'Please answer the allergy question.';
  if (formData.allergies === 'yes' && !formData.allergyDetails.trim()) {
    newErrors.allergyDetails = 'Please provide allergy details.';
  }

  if (!formData.pregnancy) newErrors.pregnancy = 'Please answer the pregnancy question.';
 

  if (!formData.retinolUse) newErrors.retinolUse = 'Please answer the retinol/Accutane question.';

  // Acknowledgment & Consent
  if (!formData.consent) newErrors.consent = 'You must accept the terms.';
  if (!formData.acknowledgement) newErrors.acknowledgement = 'You must confirm you have read and understood the form.';

  setErrors(newErrors);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if(page && page.is_enabled) {
      return;
    }
    if (validateForm()) {
      setShowModal(true)
     
    }
  };
  const fetchBlockedList = async () => {
    try {
      const response = await DataService.getBlockedDates();
      console.log('Blocked dates API response:', response);

      // Ensure we always set an array
      if (response.data && Array.isArray(response.data)) {
        setBlockedList(response.data);
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        // Handle nested response structure
        setBlockedList(response.data.data);
      } else {
        console.warn('Blocked dates API returned non-array data, using empty array');
        setBlockedList([]);
      }
    } catch (err) {
      console.error('Failed to fetch blocked list:', err);
      // Keep blockedList as empty array on error
      setBlockedList([]);
    }
  };

  const fetchSalonHours = async () => {
    try {
      const response = await DataService.getSalonHours();
      console.log('Salon hours API response:', response);

      // Handle different response structures
      let hours = null;
      if (response.data) {
        // Check if data is directly in response.data
        if (response.data.startTime && response.data.endTime) {
          hours = response.data;
        }
        // Check if data is nested (e.g., response.data.data)
        else if (response.data.data && response.data.data.startTime && response.data.data.endTime) {
          hours = response.data.data;
        }
        // Check for alternative property names (start_time, end_time)
        else if (response.data.start_time && response.data.end_time) {
          hours = {
            startTime: response.data.start_time,
            endTime: response.data.end_time
          };
        }
        else if (response.data.data && response.data.data.start_time && response.data.data.end_time) {
          hours = {
            startTime: response.data.data.start_time,
            endTime: response.data.data.end_time
          };
        }
      }

      if (hours) {
        console.log('Setting salon hours:', hours);
        setSalonHours(hours);
      } else {
        console.warn('Salon hours not found in API response, using defaults');
      }
    } catch (error) {
      console.error('Failed to fetch salon hours:', error);
      console.log('Using default salon hours: 10:00 - 19:00');
    }
  };

  useEffect(() => {
    getServices();
    fetchBlockedList();
    getPages();
    fetchSalonHours();
  }, []);
  
  useEffect(() => {
    console.log(formData)
  if (formData.date) {
    getBookingSlots(formData.date);
  }
}, [formData.date,refreshSlotsKey]);
  useEffect(() => {
  if (formData.pregnancy === 'yes') {
    const hasHydraFacial = selectedServices.some(s => s.name.toLowerCase() === 'hydra facial');
    
    if (hasHydraFacial) {
      toast.error('Hydra Facial is not allowed during pregnancy and has been removed from your selection.');
      const updatedServices = selectedServices.filter(s => s.name.toLowerCase() !== 'hydra facial');
      setSelectedServices(updatedServices);
    }
  }
}, [formData.pregnancy, selectedServices]);

function sumServiceDuration() {
  return selectedServices.reduce((sum, s) => {
    const raw = s.service_duration ?? s.service_duraion ?? s.duration ?? 0;
    const val = parseInt(raw, 10);
    return sum + (isNaN(val) ? 0 : val);
  }, 0);
}

function ticksForSlot(startLabel, durationMinutes) {
  const steps = Math.ceil(durationMinutes / 15);
  const [h0, m0] = startLabel.split(':').map(Number);
  const ticks = [];
  let curH = h0, curM = m0;
  for (let i = 0; i < steps; i++) {
    ticks.push(`${String(curH).padStart(2,'0')}:${String(curM).padStart(2,'0')}`);
    curM += 15;
    if (curM >= 60) { curM -= 60; curH += 1; }
  }
  return ticks;
}

const isToday = (() => {
  if (!formData.date) return false;
  const [y, m, d] = formData.date.split("-").map(Number);
  const now = new Date();
  return (
    now.getFullYear() === y &&
    now.getMonth() === m - 1 &&
    now.getDate() === d
  );
})();

// helper to build a Date for the SELECTED DAY + hh:mm (local, no UTC shift)
const buildSlotDate = (dateStr, hhmm) => {
  const [y, m, d] = dateStr.split("-").map(Number);       // YYYY-MM-DD
  const [H, M] = hhmm.split(":").map(Number);              // HH:mm
  return new Date(y, m - 1, d, H, M, 0, 0);                // local date-time
};

// generate and filter
const desiredDuration = sumServiceDuration(formData.services || []); // minutes
const blockedSet = new Set(bookedSlots || []); // bookedSlots from API, e.g. ["16:30","16:45"]

// const availableSlots = generateTimeSlots("10:00", "19:00", 15).filter((slot) => {
//   // if there's no date chosen, show nothing
//   if (!formData.date) return false;

//   // If the single start tick itself is already blocked, reject immediately
//   if (blockedSet.has(slot)) return false;

//   // If requested duration is zero or not provided, fall back to single-tick behavior
//   if (!desiredDuration || desiredDuration <= 0) {
//     // still apply "today" check
//     if (isToday) {
//       const slotDate = buildSlotDate(formData.date, slot);
//       return slotDate.getTime() > Date.now();
//     }
//     return true;
//   }

//   // Build the ticks this candidate needs (e.g. for 30 min => ["16:15","16:30"])
//   const requiredTicks = ticksForSlot(slot, desiredDuration);

//   // If any required tick is blocked, slot is not available
//   for (const t of requiredTicks) {
//     if (blockedSet.has(t)) return false;
//   }

//   // If the chosen date is today, keep only slots whose start is after now
//   if (isToday) {
//     const slotDate = buildSlotDate(formData.date, slot);
//     return slotDate.getTime() > Date.now();
//   }

//   // otherwise the slot is fine
//   return true;
// });
console.log(salonHours.startTime)
console.log(salonHours.endTime)
const availableSlots = generateTimeSlots(salonHours.startTime, salonHours.endTime, 15).filter((slot) => {
  if (!formData.date) return false;
  if (blockedSet.has(slot)) return false;

  // ✅ If no duration selected, allow only valid time range
  if (!desiredDuration || desiredDuration <= 0) {
    if (isToday) {
      const slotDate = buildSlotDate(formData.date, slot);
      return slotDate.getTime() > Date.now();
    }
    return slot < salonHours.endTime; // hide end time when no service is picked
  }

  const requiredTicks = ticksForSlot(slot, desiredDuration);

  // ✅ Hide if any required tick is already booked
  for (const t of requiredTicks) {
    if (blockedSet.has(t)) return false;
  }

  // ✅ HIDE if service exceeds salon end time (KEY REQUIREMENT)
  const lastTick = requiredTicks[requiredTicks.length - 1];
  if (lastTick > salonHours.endTime) return false;

  // ✅ Today-time validation
  if (isToday) {
    const slotDate = buildSlotDate(formData.date, slot);
    return slotDate.getTime() > Date.now();
  }

  return true;
});

function toAmPm(time24) {
  const [h, m] = time24.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
}

/*==========Payment section here=================*/
  const handleCloseModal = () => setShowModal(false);
  const blockedDates = (Array.isArray(blockedList) ? blockedList : [])
    .filter((item) => item.time === 'All')
    .map((item) => new Date(item.date + "T00:00:00"));

  return (
        <>
      <LoaderOverlay loading={loading} />
    <div>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Book an Appointment | Makeup and Hair | Regina SK - Divine Blush Beauty</title>
        <meta name="title" content="Book an Appointment | Makeup and Hair | Regina SK - Divine Blush Beauty" />
        <meta name="description" content="Schedule your beauty appointment at Divine Blush Beauty in Regina, SK. Expert facial treatments, waxing, makeup, and hair services. Book online 24/7 with instant confirmation." />
        <meta name="keywords" content="beauty salon Regina, book appointment Regina SK, facial Regina, waxing Regina, makeup artist Regina, hair salon Regina, beauty services Regina Saskatchewan, Divine Blush Beauty, women's salon Regina" />
        <meta name="author" content="Divine Blush Beauty" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.divineblushbeauty.ca/book-appointment" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.divineblushbeauty.ca/book-appointment" />
        <meta property="og:title" content="Book an Appointment | Divine Blush Beauty | Regina SK" />
        <meta property="og:description" content="Schedule your beauty appointment at Divine Blush Beauty in Regina, SK. Expert facial treatments, waxing, makeup, and hair services. Book online 24/7." />
        <meta property="og:image" content="https://www.divineblushbeauty.ca/images/bb.jpg" />
        <meta property="og:site_name" content="Divine Blush Beauty" />
        <meta property="og:locale" content="en_CA" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.divineblushbeauty.ca/book-appointment" />
        <meta name="twitter:title" content="Book an Appointment | Divine Blush Beauty | Regina SK" />
        <meta name="twitter:description" content="Schedule your beauty appointment at Divine Blush Beauty in Regina, SK. Expert facial treatments, waxing, makeup, and hair services." />
        <meta name="twitter:image" content="https://www.divineblushbeauty.ca/images/bb.jpg" />

        {/* Additional SEO */}
        <meta name="geo.region" content="CA-SK" />
        <meta name="geo.placename" content="Regina" />
        <meta name="geo.position" content="50.4452;-104.6189" />
        <meta name="ICBM" content="50.4452, -104.6189" />

        {/* Structured Data - Appointment Booking */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BeautySalon",
              "name": "Divine Blush Beauty",
              "url": "https://www.divineblushbeauty.ca",
              "logo": "https://www.divineblushbeauty.ca/images/Logo_salon.svg",
              "image": "https://www.divineblushbeauty.ca/images/bb.jpg",
              "description": "Premier beauty salon in Regina, SK offering professional facial treatments, waxing, makeup, and hair services exclusively for women.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "3104, Crossbie Cres",
                "addressLocality": "Regina",
                "addressRegion": "SK",
                "postalCode": "S4V3S2",
                "addressCountry": "CA"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": "50.4452",
                "longitude": "-104.6189"
              },
              "telephone": "+1-639-915-0949",
              "priceRange": "$$",
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                "opens": "${salonHours.startTime}",
                "closes": "${salonHours.endTime}"
              },
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Beauty Services",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Facial Treatments",
                      "description": "Professional facial treatments including hydra facial, chemical peels, and more"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Waxing Services",
                      "description": "Full body waxing services for smooth, hair-free skin"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Makeup Services",
                      "description": "Professional makeup application for special occasions"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Hair Services",
                      "description": "Hair styling, coloring, and treatment services"
                    }
                  }
                ]
              },
              "potentialAction": {
                "@type": "ReserveAction",
                "target": {
                  "@type": "EntryPoint",
                  "urlTemplate": "https://www.divineblushbeauty.ca/book-appointment",
                  "actionPlatform": [
                    "http://schema.org/DesktopWebPlatform",
                    "http://schema.org/MobileWebPlatform"
                  ]
                },
                "result": {
                  "@type": "Reservation",
                  "name": "Beauty Service Appointment"
                }
              }
            }
          `}
        </script>
      </Helmet>

      <section className="hero-wrap hero-wrap-2" style={{ backgroundImage: "url('images/bb.jpg')" }}
 data-stellar-background-ratio="0.5">
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
            <AnimateOnScroll className="col-md-9 text-center">
              <h1 className="mb-3 bread">Appointment</h1>
              <p className="breadcrumbs">
                <span className="mr-2"><Link to="/">Home</Link></span> Appointment
              </p>
            </AnimateOnScroll>
          </div>
        </div>
      </section>

      <section className="ftco-section contact-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-3">
              <h2 className="heading">Make an Appointment</h2>
              <small className="notice">This salon only provides services for women</small>
            </div>
          </div>
          {page && page.is_enabled && (
            <div className="booking-overlay d-flex align-items-center justify-content-center">
              <div className="booking-message text-center p-4 bg-white shadow rounded">
                {/* <h4 className="mb-3 text-danger">Bookings Temporarily Closed</h4> */}
  <div dangerouslySetInnerHTML={{ __html: page.message }} />
              </div>
            </div>
          )}
          <div className="row">
            <AnimateOnScroll className="col-md-7 contact-info p-4 bg-light">
              <form className="contact-form appointment">

                <h5 className="text-xl font-bold mb-4">Select Services</h5>
                {errors.services && <p className="text-danger">{errors.services}</p>}
                <div className="row mb-4">
                  {Object.keys(categories).map((cat) => (
                    <div className="col-sm-4 mb-2" key={cat}>
                      <label className="flex items-center gap-2 mr-4">
                        <input
                          type="radio"
                          name="mainCategory"
                          className="form-control rad"
                          value={cat}
                          checked={selectedCategory === cat}
                          onChange={() => handleCategoryChange(cat)}
                        />
                        {cat}
                      </label>
                    </div>
                  ))}
                </div>

                {selectedCategory && (
                  <div className="mb-4">
                    <h5 className="mb-4 text-lg font-semibold">
                      Select {selectedCategory} Services:
                    </h5>
                    <div className="row">
                      {categories[selectedCategory].map((service) => (
                        <div className="col-md-6 mb-2"  id="subCategorySection" key={service.id}>
                          <label className="flex items-center gap-2 text-sm">
                            <input
                              type="checkbox"
                              className="form-control"
                              checked={selectedServices.some((s) => s.id === service.id)}
                              onChange={() => handleSubCategoryToggle(service,selectedCategory)}
                            />
                            {service.name} (${service.price})
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <div className="row border-top">
                  <div className="col-md-12 mb-3 mt-4">
                    <h5 className="heading">Personal Information</h5>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={(e) => {
                      setFormData({ ...formData, name: e.target.value });
                      setErrors({ ...errors, name: '' });
                    }}
                    />
                    {errors.name && <p className="text-danger">{errors.name}</p>}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Your Email"
                      value={formData.email}
                       onChange={(e) => {
                      setFormData({ ...formData, email: e.target.value });
                      setErrors({ ...errors, email: '' });
                    }}
                    />
                    {errors.email && <p className="text-danger">{errors.email}</p>}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control mb-2"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={(e) => {
                      const input = e.target.value;
                      // Only allow digits, spaces, +, -, (, )
                      if (/^[\d\s+()-]*$/.test(input)) {
                        setFormData({ ...formData, phone: input });
                        setErrors({ ...errors, phone: '' });
                      }
                    }}
                    />
                    {errors.phone && <p className="text-danger">{errors.phone}</p>}
                  </div>
                  <div className="col-md-6">
                    {/* <input
                      type="date"
                      className="form-control mb-2"
                      min={getToday()}
                      max={getOneMonthFromToday()}
                      value={formData.date}
                      onChange={(e) => {
                      setFormData({ ...formData, date: e.target.value });
                      setErrors({ ...errors, date: '' });
                    }}
                    /> */}
                   <DatePicker
  selected={formData.date ? new Date(formData.date + 'T12:00:00') : null}
  onChange={(date) => {
    const adjustedDate = new Date(date.setHours(12, 0, 0, 0));
    const formatted = format(adjustedDate, 'yyyy-MM-dd');
    setFormData({ ...formData, date: formatted });
  }}
  excludeDates={blockedDates}
  minDate={getToday()}
  maxDate={getOneMonthFromToday()}
  dateFormat="yyyy-MM-dd"
  className="form-control"
  placeholderText="Select a date"
/>
                    {errors.date && <p className="text-danger">{errors.date}</p>}
                  </div>
                  <div className="col-md-6">
                    <select
                    className="form-control mb-2"
                    value={formData.time}
                    onChange={(e) => {
                      setFormData({ ...formData, time: e.target.value });
                      setErrors({ ...errors, time: '' });
                    }}
                    disabled={!formData.date}
                  >
                    <option value="">
                      {formData.date ? 'Select Time' : 'Select a Date First'}
                    </option>
                    {availableSlots.length > 0 ? (
                      availableSlots.map((time, idx) => (
                        <option key={idx} value={time}> {toAmPm(time)}</option>
                      ))
                    ) : (
                      formData.date && <option disabled>No slots available</option>
                    )}
                  </select>
                    {errors.time && <p className="text-danger">{errors.time}</p>}
                  </div>
                </div>

<div className="row">
  <div className="col-md-12 mb-3 mt-4">
    <h5 className="heading">Health & Safety Disclosure:</h5>
  </div>

  {/* 1. Physician Care */}
  <div className="col-md-12 mb-2" id="subCategorySection">
    <label className="text-sm">
      1. Are you currently under the care of a physician for any skin, hair, or medical condition?
    </label>
    <div className="d-flex gap-3 mb-2">
      <label class="mr-3">
        <input
          type="radio"
          name="physicianCondition"
          class="form-control rad"
          checked={formData.physicianCondition === "yes"}
          onChange={() => {
            setFormData({ ...formData, physicianCondition: "yes" });
            setErrors({ ...errors, physicianCondition: "" });
          }}
        /> Yes
      </label>
      <label>
        <input
          type="radio"
          name="physicianCondition"
          class="form-control rad"
          checked={formData.physicianCondition === "no"}
          onChange={() => {
            setFormData({ ...formData, physicianCondition: "no" });
            setErrors({ ...errors, physicianCondition: "" });
          }}
        /> No
      </label>
    </div>
    {formData.physicianCondition === "yes" && (
      <>
        <label>If yes, please specify:</label>
        <textarea
          className="form-control"
          rows="3"
          value={formData.physicianDetails}
          onChange={(e) => {
            setFormData({ ...formData, physicianDetails: e.target.value });
            setErrors({ ...errors, physicianDetails: "" });
          }}
        />
      </>
    )}
    {errors.physicianCondition && <p className="text-danger">{errors.physicianCondition}</p>}
     {errors.physicianDetails && <p className="text-danger">{errors.physicianDetails}</p>}
  </div>

  {/* 2. Allergies */}
  <div className="col-md-12 mb-2" id="subCategorySection">
    <label className="text-sm">2. Do you have any allergies (including latex, dyes, products, etc.)?</label>
    <div className="d-flex gap-3 mb-2">
      <label class="mr-3">
        <input
          type="radio"
          name="allergies"
          class="form-control rad"
          checked={formData.allergies === "yes"}
          onChange={() => {
            setFormData({ ...formData, allergies: "yes" });
            setErrors({ ...errors, allergies: "" });
          }}
        /> Yes
      </label>
      <label>
        <input
          type="radio"
          name="allergies"
          class="form-control rad"
          checked={formData.allergies === "no"}
          onChange={() => {
            setFormData({ ...formData, allergies: "no" });
            setErrors({ ...errors, allergies: "" });
          }}
        /> No
      </label>
    </div>
    {formData.allergies === "yes" && (
      <>
        <label>If yes, please specify:</label>
        <textarea
          className="form-control"
          rows="3"
          value={formData.allergyDetails}
          onChange={(e) => {
            setFormData({ ...formData, allergyDetails: e.target.value });
            setErrors({ ...errors, allergyDetails: "" });
          }}
        />
      </>
    )}
    {errors.allergyDetails && <p className="text-danger">{errors.allergyDetails}</p>}
  </div>

  {/* 3. Pregnancy */}
  <div className="col-md-12 mb-2" id="subCategorySection">
    <label className="text-sm">3. Are you pregnant or nursing?</label>
    <div className="d-flex gap-3 mb-2">
      <label class="mr-3">
        <input
          type="radio"
          name="pregnancy"
          class="form-control rad"
          checked={formData.pregnancy === "yes"}
          onChange={() => {
            setFormData({ ...formData, pregnancy: "yes" });
            setErrors({ ...errors, pregnancy: "" });
          }}
        /> Yes
      </label>
      <label>
        <input
          type="radio"
          name="pregnancy"
          class="form-control rad"
          checked={formData.pregnancy === "no"}
          onChange={() => {
            setFormData({ ...formData, pregnancy: "no" });
            setErrors({ ...errors, pregnancy: "" });
          }}
        /> No
      </label>
    </div>
    {errors.pregnancy && <p className="text-danger">{errors.pregnancy}</p>}
  </div>

  {/* 4. Retinol */}
  <div className="col-md-12 mb-2" id="subCategorySection">
    <label className="text-sm">
      4. Have you used any retinol, AHA/BHA products, or taken Accutane in the last 6 months?
    </label>
    <div className="d-flex gap-3 mb-2">
      <label class="mr-3">
        <input
          type="radio"
          name="retinolUse"
          class="form-control rad"
          checked={formData.retinolUse === "yes"}
          onChange={() => {
            setFormData({ ...formData, retinolUse: "yes" });
            setErrors({ ...errors, retinolUse: "" });
          }}
        /> Yes
      </label>
      <label>
        <input
          type="radio"
          name="retinolUse"
          class="form-control rad"
          checked={formData.retinolUse === "no"}
          onChange={() => {
            setFormData({ ...formData, retinolUse: "no" });
            setErrors({ ...errors, retinolUse: "" });
          }}
        /> No
      </label>
    </div>
    {errors.retinolUse && <p className="text-danger">{errors.retinolUse}</p>}
  </div>
</div>

{/* Acknowledgment and Consent */}
<div className="row">
  <div className="col-md-12 mb-3 mt-4">
    <h5 className="heading">Client Acknowledgment and Consent:</h5>
  </div>
  <div className="col-md-12 mb-2" id="subCategorySection">
    <p>- I understand the nature of the salon services I will be receiving.</p>
    <p>- I have disclosed all relevant health and skin/hair conditions.</p>
    <p>- I understand there may be risks associated with salon services including, but not limited to, allergic reactions, skin irritation, or injury.</p>
    <p>- I release the salon and its staff from any liability related to services rendered, provided reasonable care and professionalism has been exercised.</p>
    <p>- I give permission for photos to be taken (if applicable) for marketing or training purposes.</p>

    <label className="d-block mt-2">
      <input
        type="checkbox"
        checked={formData.consent}
        onChange={(e) => {
          setFormData({ ...formData, consent: e.target.checked });
          setErrors({ ...errors, consent: "" });
        }}
      />{" "}
      I accept the terms above.
    </label>
    {errors.consent && <p className="text-danger">{errors.consent}</p>}

    <label className="d-block mt-4">
      <input
        type="checkbox"
        checked={formData.acknowledgement}
        onChange={(e) => {
          setFormData({ ...formData, acknowledgement: e.target.checked });
          setErrors({ ...errors, acknowledgement: "" });
        }}
      />{" "}
      I confirm that I have read and understood this form and all information provided by me is true and accurate.
    </label>
    {errors.acknowledgement && <p className="text-danger">{errors.acknowledgement}</p>}
  </div>
</div>
  <button className="btn btn-primary py-3 px-5 w-full" onClick={handleSubmit}>
                  Book
                </button>

  
              </form>
            </AnimateOnScroll>

            <div className="col-md-1" />

            <AnimateOnScroll className="col-md-4 summary_sec shadow">
              <div className="sticky top-6 h-fit bg-white p-4 ">
                <h3 className="text-xl font-bold mb-3">Selected Services</h3>
                <div className="mb-3 text-sm">
                  {selectedServices.length === 0 ? (
                    <span>No services selected.</span>
                  ) : (
                    selectedServices.map((service) => (
                      <div key={service.id} className="flex selected-block mb-2 justify-between items-center">
                        <span>{service.name} (${service.price})</span>
                        <button
                          onClick={() => handleRemoveService(service.id)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <X size={16} />
                        </button>
                      </div>
                    ))
                  )}
                </div>
                <div className="Tot_block mb-4">
                  <span className="tot">Total: </span>
                  <span>${totalPrice}</span>
                  <div style={{ fontSize: '0.8rem', color: '#666' }}>(All prices in CAD)</div>
                </div>
              
              </div>
            </AnimateOnScroll>
          </div>
        </div>
      </section>
      {showModal && (
      <Payment show={showModal} onCloseWithData={(data) => {
    if (data.hasError) {
           forceRefetchSlots(); // ✅ SAFE refresh

    }
    setShowModal(false);
  }} appointmentData ={formData} totalPrice={totalPrice} selectedServices={selectedServices} paymentButton={paymentButton} payLaterButton={payLaterButton}/>
      )}
      
      <div className="selected-services-mobile d-block d-md-none">
      <div className="inner bg-white border-top px-3 py-2">
        {selectedServices.length === 0 ? (
          <div className="d-flex justify-content-between align-items-center">
            <span className="small" style={{color:'#1e1b1b'}}>No services selected.</span>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <span className="fw-semibold small" style={{color:'#1e1b1b'}}>Selected Services</span>
              <span className="fw-semibold" style={{color:'#1e1b1b'}}>
                ${totalPrice}
              </span>
            </div>

            {/* Scrollable list if many services */}
            <div className="services-list small">
              {selectedServices.map((service) => (
                <div
                  key={service.id}
                  className="d-flex justify-content-between align-items-center mb-1"
                >
                  <span className="text-truncate me-2" style={{color:'#1e1b1b'}}>
                    {service.name} (${service.price})
                  </span>
                  <button
                    type="button"
                    onClick={() => handleRemoveService(service.id)}
                    className="btn btn-link p-0 text-danger btn-sm"
                  >
                    <X size={14} />
                  </button>
                </div>
              ))}
            </div>

            <div className="text-muted mt-1" style={{ fontSize: '0.7rem',color:'#1e1b1b' }}>
              All prices in CAD
            </div>
          </>
        )}
      </div>
    </div>

    </div>
    
    </>
  );
}
